<template>
    <div :style="{'max-width': '1300px', 'width': '90%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px', 'padding-bottom': '100px'}">
        <b-card style="padding: 5px;" class="hidden-print">
            <h3>New Customer Service Ticket</h3>
            <div>
                <b-form @submit="search_sales">
                    
                    <div style="display: inline-block; vertical-align: top;">
                        <div>
                            <b-form-input style="width: 200px; display: inline-block;" v-model="query" type="text" required></b-form-input>
                        </div>
                        <sub>Enter invoice # / email / customer phone</sub>
                    </div>
                    <div style="display: inline-block; vertical-align: top;">
                        <b-button size="md" type="submit" variant="primary">Search</b-button>
                    </div>
                </b-form>
            </div>
        </b-card>

        <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
            <b-card v-if="invoices.length > 0">

                <table class="text-monospace" style="width: 100%;">
                        <thead>
                            <tr style="background: #c3cdd3;">
                                <td class="ipt_tdhr" style="width: 120px;">
                                    DATE TIME
                                </td>
                                <td class="ipt_tdhr">
                                    INVOICE ID
                                </td>
                                <td class="ipt_tdhr">
                                    CUSTOMER
                                </td>
                                <td class="ipt_tdhr">
                                    ITEMS 
                                </td>
                                
                                <td class="ipt_tdhr">
                                    ACTION
                                </td>                                
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="item,idx in invoices" v-bind:key="idx">
                                <td class="ipt_tdhr">
                                    {{ item.datetime }}
                                </td>
                                <td class="ipt_tdhr">
                                    {{ item.invoice_id }}
                                </td>
                                <td class="ipt_tdhr">
                                    {{ item.customer_fullname }}
                                </td>
                                <td class="ipt_tdhr">
                                    <b-list-group>
                                        <b-list-group-item v-for="pitem,pidx in item.items" v-bind:key="pidx" style="font-size: 11px; padding: 2px; border: 1px;">{{pitem.product_name}} x ({{pitem.quantity}})</b-list-group-item>
                                    </b-list-group>
                                </td>
                                
                                <td class="ipt_tdhr non-header">
                                    <b-button size="sm" variant="warning" @click="fetchInvoiceForCS(item)">VIEW</b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>      
                
            </b-card>

            <div v-else>
                <b-card :title="'INVOICE # '+invoice.invoice_id" v-if="invoice.items.length > 0">
                    <b-card header="ITEMS">
                        <table style="width: 100%;">
                            <thead>
                                <td class="ipt_tdhr" style="font-size: 13px;">
                                    PRODUCT
                                </td>
                                <td class="ipt_tdhr" style="font-size: 13px;">
                                    QTY
                                </td>
                                <td class="ipt_tdhr" style="font-size: 13px;">
                                    TOTAL AMT
                                </td>

                            </thead>
                            <tbody>
                                <tr v-for="item,idx in invoice.items" v-bind:data="item" v-bind:key="idx" style="border: 1px solid black;">
                                    <td class="ipt_tdhr">
                                        <div style="display: inline-block;">
                                            {{ item.product_name }}
                                        </div>

                                        <div>
                                            ({{ item.product_sku }})
                                            <span v-if="item.product_id < 0 || !item.product_id"> 
                                            <span><b-badge variant="warning" style="padding: 2px; font-size: 10px;">SPECIAL</b-badge></span>
                                        </span>
                                        </div>
                                    </td>
                            
                                    <td class="ipt_tdhr" style="font-weight: normal;">
                                        {{ item.quantity }}
                                    </td>
                            
                                    <td class="ipt_tdhr" style="font-weight: normal;">
                                        ${{ parseFloat(item.total).toFixed(2) }}
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </b-card>

                    <b-card header="ISSUES" style="margin-top: 10px;">
                        <b-button size="md" variant="success" @click="addNewIssue">New Issue</b-button>

                        <b-card-group deck>
                            <b-card style="max-width: 20rem; min-width: 20rem; margin: 5px;" v-for="issue,isidx in issues" v-bind:key="isidx" :header="'ISSUE # '+(isidx+1)">
                                <b-card-text style="font-size: 11px;">
                                    <div>PRODUCT</div>
                                    <div>
                                        <b-form-select :options="invoice.items.map(function(d){return {value: d.product_sku, text: d.product_name} })" size="sm" style="font-size: 11px; width: 200px;" v-model="issue.product_sku"></b-form-select>
                                    </div>
                                </b-card-text>

                                <b-card-text style="font-size: 11px;">
                                    <div>CLAIM DATE</div>
                                    <div>
                                        <flat-pickr v-model="issue.claim_date" :config="{ dateFormat: 'm-d-Y' }" style="width: 200px; display: block; border: 1px solid #d1d1d1; padding: 6px;"></flat-pickr>
                                    </div>
                                </b-card-text>

                                <b-card-text style="font-size: 11px;">
                                    <div>STATUS</div>
                                    <div>
                                        <b-form-select :options="statuses" size="sm" style="font-size: 11px; width: 200px;" v-model="issue.status"></b-form-select>
                                    </div>
                                </b-card-text>

                                <b-card-text style="font-size: 11px;">
                                    <div>REPAIR / EXCHG COST</div>
                                    <div>
                                        <b-input size="sm" style="font-size: 11px; width: 200px; text-align: left;" v-model="issue.fix_cost"></b-input>
                                    </div>
                                </b-card-text>

                                <b-card-text style="font-size: 11px;">
                                    <div>ACTION</div>
                                    <div>
                                        <b-form-select :options="action_types" size="sm" style="font-size: 11px; width: 200px;" v-model="issue.action"></b-form-select>
                                    </div>
                                </b-card-text>

                                <b-card-text style="font-size: 11px;">
                                    <div>PARTS ORDER</div>
                                    <div>
                                        <b-form-select :options="parts_options" size="sm" style="font-size: 11px; width: 200px;" v-model="issue.parts_order"></b-form-select>
                                    </div>
                                </b-card-text>

                                <b-card-text style="font-size: 11px;">
                                    <div>SCHEDULED DATE</div>
                                    <div>
                                        <flat-pickr v-model="issue.scheduled_date" :config="{ dateFormat: 'm-d-Y' }" style="width: 200px; display: block; border: 1px solid #d1d1d1; padding: 6px;"></flat-pickr>
                                    </div>
                                </b-card-text>

                                <b-card-text style="font-size: 11px;">
                                    <div>CLAIM DETAIL</div>
                                    <div>
                                        <b-textarea size="sm" style="font-size: 11px; width: 200px;" v-model="issue.claim_detail" placeholder="add any details here." rows="10"></b-textarea>
                                    </div>
                                </b-card-text>

                                <b-card-text>
                                    <b-button size="sm" variant="primary" @click="saveIssue(issue)">SAVE</b-button>
                                </b-card-text>
                            </b-card>


                        </b-card-group>
                    </b-card>
                </b-card>
            </div>
        </b-overlay>

    </div>
</template>

<script>
    import _ from 'underscore'
    import moment from 'moment'
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        name: "CSTicket",
        components: {Backer, flatPickr},
        data: function(){
            return {
                packet: {},
                query: null,
                invoices: [],
                invoice: {items: []},
                issues: [],
                invoice_id: null,
                items_being_loaded: false,
                message: "No invoice loaded",
                items: [],
                refund_being_generated: false,
                existing_refunds: [],
                conditions: [
                    {value: 1, text: "New"},
                    {value: 2, text: "Open Box"},
                    {value: 3, text: "Damaged"},
                    {value: 4, text: "Never Delivered"}
                ],
                refund_payment_modes: [
                    {value: 1, text: "Credit Card"},
                    {value: 2, text: "Cash"},
                    {value: 3, text: "Store Credit"}
                ],
                action_types: [
                    {value: "exchange", text: "Exchange"},
                    {value: "repair_at_ch", text: "Repair At Customer House"},
                    {value: "repair_at_wh", text: "Repair At Warehouse"},
                    {value: "order_parts_with_mfg", text: "Order Parts with Mfg"},
                    {value: "not_covered", text: "Not Covered"},
                    {value: "covered_under_extended_warranty", text: "Covered Under Extended Warranty"}

                ],

                parts_options: [
                    {value: "delivered_by_mfg", text: "Delivered By Mfg"},
                    {value: "delivered_by_store", text: "Delivered By Store"},
                    {value: "pickup_by_customer", text: "Pickup By Customer"},

                ],

                statuses: [
                    {value: "new", text: "New"},
                    {value: "open", text: "Open"},
                    {value: "assigned", text: "Assigned"},
                    {value: "resolved", text: "Resolved"},
                    {value: "exchange", text: "Exchange"},
                     {value: "denied", text: "Denied"},
                    {value: "closed", text: "Closed"},
                    {value: "pending", text: "Pending"}
                ],
                hovered_image: {},
            }
        },
        methods: {
            saveIssue: function(issue){
                if (!issue.invoice_id){
                    this.$vex.dialog.alert({
                        message: "Please specify a valid invoice id."
                    });
                    return
                }

                if (!issue.product_sku){
                    this.$vex.dialog.alert({
                        message: "Please specify a valid product for the issue."
                    });
                    return
                }

                if (!issue.itemid){
                    this.$vex.dialog.alert({
                        message: "Please specify a valid product for the issue."
                    });
                    return
                }

                if (!issue.status){
                    this.$vex.dialog.alert({
                        message: "Please specify a status for the issue."
                    });
                    return
                }

                if (isNaN(parseFloat(issue.fix_cost))){
                    this.$vex.dialog.alert({
                        message: "Please specify a valid repair / exchg cost."
                    });
                    return
                }


                let that = this;
                let path = "/api/customer_service/save/"
                let data = issue;
                data.fix_cost = parseFloat(data.fix_cost);

                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Saved Issue.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                }
                let f = function(error) {
                    that.$bvToast.toast(
                        "Error saving issue. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
                Requestor.postSyncP(path, data, this, s, f);
            },
            addNewIssue: function(e){
                if (e){
                    e.preventDefault()
                }

                let issue = {
                    invoice_id: this.invoice.invoice_id,
                    product_sku: null,
                    claim_date: null,
                    status: null,
                    fix_cost: null,
                    claim_detail: null,
                    images: [],
                    action: null,
                    scheduled_date: null,
                    comments: null
                }

                this.issues.push(issue);
            },
            previewImage: function(event) {
                // Reference to the DOM input element
                var input = event.target;


                // Ensure that you have a file before attempting to read it
                if (input.files && input.files[0]) {
                    let img = {raw: "", url: "", file: null}
                    // create a new FileReader to read this image and convert to base64 format
                    var reader = new FileReader();
                    // Define a callback function to run, when FileReader finishes its job
                    reader.onload = (e ) => {
                        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                        // Read image as base64 and set to imageData
                        img.raw = e.target.result
                        this.issue.images.push(img);
                    }
                    // Start the reader job - read file as a data url (base64 format)
                    img = {raw: "", url: "", file: input.files[0]}  
                    
                    reader.readAsDataURL(input.files[0]);
                }
            },
            search_sales: function(e){
                if (e){
                    e.preventDefault();
                }

                if (!this.query){
                    this.$vex.dialog.alert({message: "Please enter a valid search term."})
                    return
                }

                let path = "/api/sales/get_sales/"
                //this.search_term = this.search_term.replace(/\s+$/,"").replace(/^\s+/,"");
                let data = {query: {invoice_id: this.query}, userid: this.packet.userDetails.id}
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        that.invoices = response.data.result
                        
                        if (that.invoices.length <= 0){
                            that.message = "No invoices found."
                        }
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading invoice. Please try again later.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded=true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            fetchInvoiceForCS: function(invoice){
                this.invoices = [];
                this.invoice = invoice;

                let path  = "/api/customer_service/get_ticket_by_invoice_id/"
                let data = {invoice_id: this.invoice.invoice_id};
                let that = this;
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.issues = response.data.result;
                    }
                    that.items_being_loaded = false;
                }

                let f = function(error){

                    that.$bvToast.toast(
                        "Error fetching issues for the invoice. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded=true;
                Requestor.getAsync(path, data, s, f);
                return
            },
            anyItemRefundable: function(){
                let items = this.items.filter(function(d){
                    return (
                        isNaN(parseInt(d.refund_amount)) == false 
                    ) && (
                        !(d.refund_ts)
                    )
                });

                if (items.length > 0){
                    return false
                }
                else {
                    return true
                }
            },
            removeRefundElement: function(idx, ridx){
                this.invoice.items[idx].refund_elements.splice(ridx, 1);
            },
            processRefund: function(e){
                if (e){
                    e.preventDefault();
                }
                let that = this;
                let refund_elements = this.invoice.items.map(function(d){
                    return d.refund_elements.filter(function(f){
                        return (f.ts === null) && ((parseInt(f.refund_quantity) ||0) > 0);
                    }).map(function(f){
                        f.refund_amount = (
                        ((parseFloat(d.total) * 0.10) + parseFloat(d.total)) 
                        / (parseInt(d.quantity))) * (parseInt(f.refund_quantity) || 0);
                        f.product_id = d.product_id;
                        f.product_sku = d.product_sku;
                        f.invoice_id = that.invoice.invoice_id;
                        return f;
                    })
                });
                refund_elements = _.flatten(refund_elements);

                if (refund_elements.length > 0) {
                    let data = {
                       invoice_id: this.invoice.invoice_id,
                    }
                    data.refund_elements = refund_elements;
                    data.delivery_refunded = this.invoice.delivery_refunded;
                    data.warranty_refunded = this.invoice.warranty_refunded;
                    data.setup_refunded = this.invoice.setup_refunded;

                    let path = "/api/sales/generate_refund/";
                    let s = function(response){
                        if (response.data.error){
                            that.$bvToast.toast(
                                response.data.error, 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        else {
                            that.$bvToast.toast(
                                "Refund processed successfully.", 
                                {title: "Success", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        that.items_being_loaded = false;
                    }

                    let f = function(error){
                        console.log(error)
                        that.$bvToast.toast(
                            "Error processing refund. Please try again later.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        that.items_being_loaded = false;
                    }
                    this.items_being_loaded=true;
                    Requestor.postSyncP(path, data, this, s, f);
                }
            }
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            //this.fetch_prereqs()
        }
    }
</script>

<style scoped>
    td {
        border: 1px solid gray;
        font-size: 12px;
    }

    .input-txt {
        border: 0px; 
        font-weight: normal; 
        color: #2c3e50; 
        display: inline; 
        padding: 0px; 
        margin: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/CustomerService/CSTicket.vue